import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {OutletCustomObjectTypeEntityModel} from "../outlet-custom-object-type-entity.model";
import {CustomObjectTypeEditPageComponent} from "./custom-object-type-edit-page.component";
import {OutletCustomObjectEditPageComponent} from "../../custom-object/custom-object-edit-page/outlet-custom-object-edit-page.component";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-outlet-custom-object-type-edit-page",
    templateUrl: "./custom-object-type-edit-page.component.html",
    providers: [provideEntityModel(OutletCustomObjectTypeEntityModel)]
})
export class OutletCustomObjectTypeEditPageComponent extends CustomObjectTypeEditPageComponent {
    override CustomObjectEditPageComponent = OutletCustomObjectEditPageComponent;
    override fixedType: boolean = true;

    constructor(model: OutletCustomObjectTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
